<template>
  <div class="add-pay-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="550px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
        label-width="150px"
        :label-position="labelPosition"
      >
        <div class="form-flex-box">
          <el-form-item label="背景图:" prop="officialImg">
            <base-upload
              class="upload"
              :cover="params.officialImg"
              :action="action"
              :wSize="180"
              :hSize="120"
              :width="'180px'"
              :height="'120px'"
              @successCallback="handleAvatarSuccess"
            >
            </base-upload>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="名称(不可重复):" prop="officialName">
            <el-input v-model="params.officialName"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="描述:" prop="officialDesc">
            <el-input v-model="params.officialDesc"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="排序:" prop="sort">
            <el-input v-model.number="params.sort"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="下载链接:" prop="officialUrl">
            <el-input v-model="params.officialUrl"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="启用/禁用:">
            <el-switch v-model="params.isActive"></el-switch>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="是否首页广告开关:">
            <el-switch v-model="params.isHomepageAds"></el-switch>
          </el-form-item>
        </div>
        <div class="form-flex-box" v-if="this.type === 'add'">
          <el-form-item label="类型:" prop="officialType">
            <el-select
              v-model="params.officialType"
              size="small"
              placeholder="请选择类型"
              clearable
            >
              <el-option
                v-for="item in officialType"
                :value="item.value"
                :label="item.label"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="位置:" prop="position">
            <el-select
              v-model.number="params.position"
              size="small"
              placeholder="请选择位置"
              clearable
            >
              <el-option
                v-for="item in positions"
                :value="item.value"
                :label="item.label"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('form')"
          :loading="flag"
          size="small"
        >
          确 认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      labelPosition: "left",
      dialogVisible: false,
      title: "",
      flag: false,
      id: "",
      type: "",
      action: baseConfig.baseServerUrl + "/agent/upload/static",
      params: {
        officialName: "",
        officialDesc: "",
        officialImg: "",
        officialUrl: "",
        isActive: false,
        officialType: "",
        isHomepageAds: false,
        sort: 0,
        position: 0,
      },
      rules: {
        officialName: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
        officialUrl: [
          { required: true, message: "请输入下载链接", trigger: "blur" },
        ],
        officialType: [
          { required: true, message: "请选择类型", trigger: "blur" },
        ],
      },
      officialType: [
        { label: "下载", value: "1" },
        { label: "社区", value: "2" },
      ],
      positions: [
        { label: "装机必备", value: 1 },
        { label: "华人国产", value: 2 },
      ],
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.addProduct();
          } else {
            this.editProduct();
          }
        } else {
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        officialName: "",
        officialImg: "",
        officialUrl: "",
        isActive: false,
        isHomepageAds: false,
        sort: 0,
      };
      this.$refs["form"].resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑官方下载配置";
        this.params = { ...data };
        this.id = data.id;
      } else {
        this.title = "新增官方下载配置";
      }
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.params.officialImg = res.data.coverImg;
    },

    // 新增商品
    addProduct() {
      API.addOfficial(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("handlerOfficialList");
          } else {
            this.$message.error("添加失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑商品
    editProduct() {
      let form = Object.assign(this.params, {
        id: this.id,
      });
      API.updOfficial(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.$emit("handlerOfficialList");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
  },
};
</script>

<style lang="scss">
.add-pay-box {
  .el-input {
    width: 300px;
  }

  .flex-item {
    width: 90%;
    display: flex;

    .el-form-item {
      flex: 1;
    }
  }

  .form-flex-box {
    display: flex;

    .el-form-item {
      flex: 1;
    }

    .item-box {
      display: flex;
      flex-direction: column;
    }
  }

  .avatar-uploader {
    width: 150px;
    height: 150px;
  }

  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border: 1px dashed #e63765;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  .privileges .el-input--suffix {
    width: 480px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;

    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
